<ul class="ols-checkbox-group">
  <li class="ols-checkbox" *ngFor="let groep of groepen" [ngClass]="{'selected': antwoordGeselecteerd(groep)}">
    <div class="ols-check" (click)="multiselectClicked(groep)" [id]="geefMeetidMulti(vraag.titel, groep.groep_titel)">
      <div class='ols-box'>
        <div class='outer'>
        </div>
      </div>
      <div class='text'>
        <div class="ols-heading-5">{{groep.groep_titel}}</div>
        <div *ngFor='let regel of groep.antwoordregels'>{{regel}}</div>
      </div>
    </div>

    <div class="ols-antwoord-content">
      <div class='ols-upload'>
        <app-file-drop (fileDrop)="dropped($event, groep)" (fileOver)="fileOver($event)" (fileLeave)="fileLeave($event)"
          class="ols-filedrop">
          <div class="ols-upload-container"
            [ngClass]="{'hovered' : isHovered, 'filesAdded' : isMobileView() && resultaatGroep(groep).length > 0}">
            <div class="upload">
              <input [accept]="groep.inputAllowExtensions" type="file" #newFile name="newfile{{groep.id}}"
                (change)="onFileChanged($event, groep)" id="newfile{{groep.id}}" class="inputfile" multiple />
              <label for="newfile{{groep.id}}" [id]="geefMeetidFile(groep.groep_titel)">
                <div class="ols-cross-ph">
                  <div class="ols-cross"></div>
                </div>
                <span [innerHTML]="groep.titel"></span>
              </label>
            </div>
          </div>
        </app-file-drop>
        <div *ngIf="resultaat && resultaatGroep(groep).length > 0" data-hj-suppress class="uploadfiles-container">
          <div *ngFor="let file of resultaatGroep(groep); let fileIndex = index" class="uploadfile">
            <div class="thumbnail_filename">
              <div class="thumbnail" [ngClass]="{'doc' : !isFileImage(file.name)}">
                <img *ngIf="!isFileImage(file.name)" src="/assets/icons/ols/document.svg" />
                <img *ngIf="isFileImage(file.name)" [src]="file.dataUrl | sanitizeUrl" />
              </div>
              <div class="filename">{{file.name}}</div>
              <div class="delete" (click)="deleteFile(file, groep)" [id]="geefMeetidIndex('verwijderen', fileIndex)">
                <img src="/assets/icons/ols/prullenbak.svg" />
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="groep.errorMessage.length > 0" class="ols-error-container">
          <div *ngFor="let message of groep.errorMessage" class="ols-error">
            {{message}}
          </div>
        </div>
      </div>
    </div>
  </li>
  <div *ngIf="indexFileToDelete > -1" class="modal is-shown ols-delete-popup">
    <div role="dialog document" arial-label="Verwijderen" class="modal__window">
      <focus-trap tabindex="0">
        <div class="modal__inner">
          <div class="modal__header">
            <h2 class="modal__header-title">Bestand verwijderen?</h2>
          </div>
          <div class="modal__content">
            <div class="ols-filename">{{deleteFilename}}</div>
            <div class="media__actions">
              <a class="button button--schade has-ripple" (click)="verwijderen()"
                [id]="geefMeetid('verwijderen_definitief')">Verwijderen</a>
              <a class="button-link" (click)="annuleerVerwijderen()"
                [id]="geefMeetid('verwijderen_annuleren')">Annuleren</a>
            </div>
          </div>
        </div>
      </focus-trap>
    </div>
  </div>
</ul>
<p class="error-block" *ngIf="submitClicked && selectedIds.length === 0">Kies welke documenten je wilt toevoegen</p>
<p class="error-block" *ngIf="submitClicked && selectedIds.length > 0 && resultaat.uploadedFiles.length === 0">Voeg een document toe</p>